export const APP_ALERT_EVENT = 'gorides:app-alert';

export const showAppAlert = ({ type = 'error', title, message }) => {
  window.dispatchEvent(new CustomEvent(APP_ALERT_EVENT, {
    detail: {
      id: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
      type,
      title,
      message
    }
  }));
};
